/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { enableProdMode } from '@angular/core'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { platformBrowser } from '@angular/platform-browser'

if (environment.production) {
  enableProdMode()
}

injectDesignSystemCdn()
platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))

function injectDesignSystemCdn() {
  window.location.href.includes('.cn')
    ? ((window as any).PORSCHE_DESIGN_SYSTEM_CDN = 'cn')
    : ((window as any).PORSCHE_DESIGN_SYSTEM_CDN = 'auto')
}
